document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('guarantee-overlay');

  if (!overlay) return;

  // Move overlay to <body> so it is never trapped inside a stacking context
  // (e.g. position:sticky product column, overflow:hidden hero section).
  // This makes position:fixed work correctly across all pages.
  document.body.appendChild(overlay);

  const openTriggers = document.querySelectorAll('[data-guarantee-trigger]');
  const closeTrigger = overlay.querySelector('[data-guarantee-close]');

  function openPopup() {
    overlay.style.display = 'flex';
    overlay.classList.add('active');
    history.pushState({ ingredientDrawer: 'open' }, '', '#guarantee-popup');
  }
  function closePopup() {
    overlay.style.display = 'none';
    overlay.classList.remove('active');
    if (location.hash === '#guarantee-popup') {
      history.back();
    }
  }
  openTriggers.forEach((trigger) => {
    trigger.addEventListener('click', openPopup);
  });
  if (closeTrigger) {
    closeTrigger.addEventListener('click', closePopup);
  }
  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) {
      closePopup();
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && overlay.classList.contains('active')) {
      closePopup();
    }
  });
  window.addEventListener('popstate', () => {
    if (overlay.classList.contains('active')) {
      closePopup();
    }
  });
});
